import gql from "graphql-tag";

const JOURNEY_KML_QUERY = gql`
  query JourneyKML($assetId: Int, $startDate: Datetime, $endDate: Datetime) {
    journeyKML(assetId: $assetId, startDate: $startDate, endDate: $endDate)
  }
`;

export default JOURNEY_KML_QUERY;
